import { render } from "./GravyLayout.vue?vue&type=template&id=cf0f3816"
import script from "./GravyLayout.vue?vue&type=script&lang=js"
export * from "./GravyLayout.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/whisk/whisk/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__